import {Component, HostListener, OnInit} from '@angular/core';
import {animation} from '../../shared/animations/animations';
import {ActivatedRoute, Router} from '@angular/router';
import {AuthTokenService} from '../../shared/services/auth-token.service';
import {SurveyService} from './surveys.service';
import {ClientEnum, ClientModel, SurveyItemModel, SurveySearchPDModel} from './../../models/survey/survey.model';
import {PreviousUrlService} from '../../shared/services/previous-url.service';
import {ToasterService} from 'angular5-toaster/dist';
import { UserModel } from '../../models/user/users.model';

@Component({
  selector: 'app-surveys',
  templateUrl: './surveys.component.html',
  styleUrls: ['./surveys.component.less'],
  animations: [animation]
})

export class SurveysComponent implements OnInit {

  private CLIENT_FILTER_KEY = 'client_filter_key';

  filter = false;
  surveys: Array<any>;
  column = 'Title';
  isDesc = false;
  date = '11/12/2016';
  dropdownLabel = 'Select';
  status = ['active', 'inactive'];
  created = ['John', 'Marie'];
  title: string;
  loader = false;
  showDeletePopup: boolean;
  surveyForDelete;
  filterSurvey: string;
  surveysFilter: SurveyItemModel[];
  surveySearchPDModel: SurveySearchPDModel;
  isAdmin = AuthTokenService.isAdmin();
  isCustomerAdmin = AuthTokenService.isCustomerAdmin();
  isShowWordCloud = AuthTokenService.isShowWordCloud();
  clients: ClientModel[];
  clientSelected: ClientModel;
  currentUser: UserModel;
  client: ClientModel;
  constructor(private router: Router,
              private route: ActivatedRoute,
              private surveyService: SurveyService,
              private shareService: PreviousUrlService,
              private toasterService: ToasterService) 
  {
    this.currentUser = AuthTokenService.getUser();
    this.route.data.subscribe(data => {
        this.client = data.client;
        this.clients = data.clients;
        this.clients = this.clients.filter(m=> m.active === true);

        if (this.isAdmin) {
            if (sessionStorage.getItem(this.CLIENT_FILTER_KEY) !== null) {
                this.clientSelected = JSON.parse(sessionStorage.getItem(this.CLIENT_FILTER_KEY));
                let client = this.clients.find(item => {
                    return item.id == this.clientSelected.id;
                });
                if (client === undefined) {
                    client = this.clients.find(item => {
                        return item.name == ClientEnum.INTERNAL;
                    });
                    if (client !== undefined) {
                        this.clientSelected = client;
                        sessionStorage.setItem(this.CLIENT_FILTER_KEY, JSON.stringify(this.clientSelected));
                    }
                } else {
                    this.clientSelected = client;
                    sessionStorage.setItem(this.CLIENT_FILTER_KEY, JSON.stringify(this.clientSelected));
                }
            }
            else
            {
                const client = this.clients.find(item => {
                    return item.name == ClientEnum.INTERNAL;
                });
                if (client !== undefined) {
                    this.clientSelected = client;
                    sessionStorage.setItem(this.CLIENT_FILTER_KEY, JSON.stringify(this.clientSelected));
                }
            }
        } else {
            const client = this.clients.find(item => {
                return item.id == this.currentUser.clientId;
            });
            if (client !== undefined) {
                this.clientSelected = client;
            }
        }
    });
  }

  @HostListener('document:keyup', ['$event'])
  handleKeyboardEvent(event: KeyboardEvent) {
    if (event.keyCode === 27) {
      this.closeFilter();
    }
  }

  ngOnInit() {
    this.loader = true;
    this.shareService.setSurveyTitle('Survey List');
    this.fetchData();
  }

  fetchData() {
    this.surveyService.getSurveyPDModel(this.clientSelected.id).subscribe(
      (response) => {
        this.surveySearchPDModel = response;
        this.surveySearchPDModel.listSurveyItem.sort((a, b) => {
          const aName = a.workspaceName ? a.workspaceName : a.title;
          const bName = b.workspaceName ? b.workspaceName : b.title;
          return aName.toLowerCase() > bName.toLowerCase() ? 1 : -1;
        });
        this.loader = false;
        for (const x of this.surveySearchPDModel.listSurveyItem) {
          this.title = x.title;
        }
        this.surveysFilter = this.surveySearchPDModel.listSurveyItem;
        this.searchSurveys();
      },
      (error) => {
        this.loader = false;
      }
    );
  }

  uploadCSV() {
    document.getElementById('csvfile').click();
  }

  importTypeform() {
    console.log('Import typeform');
  }

  importCSV(e) {
    const files = e.target.files;
    if (files && files.length) {
      this.loader = true;
      this.surveyService.importSpreadsheet(files).subscribe(res => {
        if (res) {
          this.surveyService.getSurveyPDModel(this.clientSelected.id).subscribe(
            (response) => {
              this.toasterService.pop('success', 'Survey has been uploaded successfully.');
              this.loader = false;
              this.surveySearchPDModel = response;
              this.loader = false;
              for (const x of this.surveySearchPDModel.listSurveyItem) {
                this.title = x.title;
              }
            },
            (error) => {
              this.loader = false;
            }
          );
        }
      }, error => {
        this.loader = false;
      });
    }
  }

  deleteSurveyConfirm(survey) {
    this.surveyForDelete = survey;
    this.showDeletePopup = true;
  }

  deleteSurvey() {
    this.loader = true;
    this.showDeletePopup = false;
    this.surveyService.deleteSurveyFull(this.surveyForDelete.id).subscribe(res => {
      if (res) {
        this.surveySearchPDModel.listSurveyItem.splice(this.surveySearchPDModel.listSurveyItem.indexOf(this.surveyForDelete), 1);
        this.loader = false;
        this.surveyForDelete = null;
      }
    }, error => {
      this.loader = false;
    });
  }

  sort(survey) {
    this.isDesc = !this.isDesc;
    this.column = survey;
    const direction = this.isDesc ? 1 : -1;

    this.surveySearchPDModel.listSurveyItem.sort(function (a, b) {
      if (a[survey] < b[survey]) {
        return -1 * direction;
      } else if (a[survey] > b[survey]) {
        return 1 * direction;
      } else {
        return 0;
      }
    });
  }

  openFilter() {
    this.filter = true;
  }

  closeFilter() {
    this.filter = false;
  }

  navigateToSurveyAnalysis(s) {
    this.router.navigate(['/surveys/master-summary/' + s.id]);
  }

  navigateToSurvey(s) {
    this.router.navigate(['/surveys/new/' + s.id]);
  }

  searchSurveys() {
    this.filterSurvey = this.filterSurvey ? this.filterSurvey.trim() : '';
    this.surveySearchPDModel.listSurveyItem =
      this.surveysFilter.filter(x => x.title.toLowerCase().indexOf(this.filterSurvey.toLowerCase()) !== -1
        || (x.workspaceName && x.workspaceName.toLowerCase().indexOf(this.filterSurvey.toLowerCase()) !== -1));
  }

  reload() {
      this.loader = true;
      this.fetchData();
  }

  filterSurveyByClient(e): void {
      this.clientSelected = e;
      sessionStorage.setItem(this.CLIENT_FILTER_KEY, JSON.stringify(this.clientSelected));
      this.fetchData();
  }

  isAllowImport(): boolean {
      return this.isAdmin || (this.isCustomerAdmin && ((this.currentUser.allowImportTypeForm && this.client.typeFormActivated) || (this.currentUser.allowImportSurveyMonkey && this.client.surveyMonkeyActivated) || this.currentUser.allowImportCSV));
  }

  toImportPage() {
      if (this.isAdmin || (this.isCustomerAdmin && (this.currentUser.allowImportTypeForm && this.client.typeFormActivated))) {
        this.router.navigate(['/surveys/import-typeform']);
      } else if (this.isAdmin || (this.isCustomerAdmin && (this.currentUser.allowImportSurveyMonkey && this.client.surveyMonkeyActivated))) {
        this.router.navigate(['surveys/import-survey-monkey']);
      } else if (this.isAdmin || (this.isCustomerAdmin && (this.currentUser.allowImportCSV))) {
        this.router.navigate(['surveys/import-csv']);
      }
  }

  onSupportClick() {
    window.open('https://support.noboa.org', '_blank');
  }
}



// WEBPACK FOOTER //
// ./src/app/routes/surveys/surveys.component.ts